import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { COMMON_CONSTANTS } from '../common/core/common.constants';
import { HttpCacheService } from './http-cache.service';
import {  Subject } from 'rxjs';
import { environment } from '../../environments/environment';
import { EnvironmentDetailsService } from './environment-details.service';
import { each} from 'lodash';
import { HelperUtilityService } from './helper-utility.service';
import { PnpClientService } from 'src/pnpframework/public-api';
import { ContentService } from './content.service';
import { WindowServiceService } from './window-service.service';
@Injectable({
  providedIn: 'root',
})
export class OktaAuthorizationService {

  public restrictAccess  = new Subject();
  public notifyUserInfo = new Subject();
  constructor(private _cacheSvc: HttpCacheService,
              private http: HttpClient,
              private _envSvc: EnvironmentDetailsService,
              private _helperUtilSvc: HelperUtilityService,
              private _pnpClientService: PnpClientService,
              private _contentService: ContentService,
              private _windowService: WindowServiceService
              ) {
  }

  loginWithOkta() {
    let oktaAuthUrlPath =
    this._envSvc.APIGEE_TOKEN_URLS.OKTA_ISSUER.path.replace(COMMON_CONSTANTS.OKTA_REDIRECT_URI, environment.oktaRedirectUrl);
    oktaAuthUrlPath =
      oktaAuthUrlPath.replace(COMMON_CONSTANTS.OKTA_ISSUER_CODE, environment.OKTA_ISSUER_CODE);
    oktaAuthUrlPath = oktaAuthUrlPath.replace(COMMON_CONSTANTS.OKTA_CLIENT_ID, environment.oktaClientId);

    const oktaAuthUrl = environment.oktaHost + oktaAuthUrlPath;
    this._windowService.redirectTo( oktaAuthUrl);
    return true;
  }

  public getOktaaAccessToken(): any {
    if (this._pnpClientService.isRunningInGlobalNav()) {
      return this._pnpClientService.getTokens()
      .then(async tokens => {
        await this.setAuthoringContent();
        return {
          access_token: tokens.accessToken,
          id_token: tokens.idToken
        }
      });
    }

    if (typeof (Storage) !== COMMON_CONSTANTS.UNDEFINED_KEY) {
        const grant_type = COMMON_CONSTANTS.AUTHORIZATION_CODE;
        const redirect = environment.oktaRedirectUrl;
        const body = `grant_type=${grant_type}&code=${sessionStorage.getItem('oktaAuthCode')}&redirect_uri=${redirect}`;

        const httpOptions = {
            headers: new HttpHeaders(
                {
                    'content-Type': COMMON_CONSTANTS.HEADER_PROPERTIES.OKTAAPPLICATION_JSON_KEY,
                    'cache-control': COMMON_CONSTANTS.HEADER_PROPERTIES.NO_CACHE,
                    'accept': COMMON_CONSTANTS.HEADER_PROPERTIES.APPLICATION_JSON_KEY,
                    'transactionID': this._helperUtilSvc.getTransactionID(),
                },
            ),
        };
        // if (environment.mocked_all || environment.mocked_endpoints) {
        //     return this.http.get(this._envSvc.APIGEE_TOKEN_URLS.OKTA_TOKEN.path).toPromise();
            // tslint:disable-next-line:max-line-length
        // const oktaTokenUrl = this._envSvc.APIGEE_TOKEN_URLS.OKTA_TOKEN.path.replace(COMMON_CONSTANTS.OKTA_ISSUER_CODE, environment.OKTA_ISSUER_CODE);
        return this.http.post(this._envSvc.APIGEE_TOKEN_URLS.OKTA_TOKEN, body, httpOptions).toPromise();
        // }
    }
    return Promise.resolve();
  }

  getOktaUserProfile(): any {
    if (this._pnpClientService.isRunningInGlobalNav()) {
      return this._pnpClientService.getUserInfo();
    }

    if (typeof (Storage) !== COMMON_CONSTANTS.UNDEFINED_KEY) {

        const httpOptions = {
            headers: new HttpHeaders(
                {
                    'cache-control': COMMON_CONSTANTS.HEADER_PROPERTIES.NO_CACHE,
                    // tslint:disable-next-line:max-line-length
                'Authorization': COMMON_CONSTANTS.HEADER_PROPERTIES.BEARER_KEY + sessionStorage.getItem(COMMON_CONSTANTS.OKTA_ACCESS_TOKEN_KEY),
                'transactionID': this._helperUtilSvc.getTransactionID(),
                },
            ),
        };
        // if (environment.mocked_all || environment.mocked_endpoints) {
        //     return this.http.get(this._envSvc.APIGEE_TOKEN_URLS.OKTA_USERINFO.path).toPromise();
        //   } else {
                          // tslint:disable-next-line:max-line-length
            const oktaUserUrl = this._envSvc.APIGEE_TOKEN_URLS.OKTA_USERINFO?.path.replace(COMMON_CONSTANTS.OKTA_ISSUER_CODE, environment.OKTA_ISSUER_CODE);
            return this.http.post(oktaUserUrl, null, httpOptions).toPromise();
          // }
    }
    return Promise.resolve();
  }
  clearCookies(){
    //Delete all the cookies
    let replaceStr = '=;expires=' + new Date().toUTCString();
    replaceStr += ';path=/;secure';
    each(document.cookie.split(';'),function(c) {
      document.cookie = c.replace(/^ +/, '').replace(/=.*/, replaceStr);
    });
  }
  logOutFromOkta() {
    let orgId = this._helperUtilSvc.getOrgID();
    let userId = this._helperUtilSvc.getUserId();
    let oktaLogOutUrl = environment.OKTA_LOGOUT+'/logout?pid='+btoa('orgId='+orgId+'&userId='+userId+'&IDPType='+COMMON_CONSTANTS.OKTA_KEY);

    this._cacheSvc.clearSessionStorage();
    this._cacheSvc.clearLocalStorage();
    this.clearCookies();
    this._windowService.redirectTo( oktaLogOutUrl);
  }

  logOutFromIAM(){
    let orgId = this._helperUtilSvc.getOrgID();
    let userId = this._helperUtilSvc.getUserId();
    let logoutUrl = environment.IAM_LOGOUT+'/logout?pid='+btoa('orgId='+orgId+'&userId='+userId+'&IDPType='+COMMON_CONSTANTS.IAM_KEY);

    this._cacheSvc.clearSessionStorage();
    this._cacheSvc.clearLocalStorage();
    this.clearCookies();
    this._windowService.redirectTo(logoutUrl);
  }

  public async setAuthoringContent() {
    return this._contentService.GetContentData(
      this._envSvc.CURR_CONTENT_URLS.CONTENT_ACCOUNT_MANAGEMENT
    ).then((data) => {
      this._cacheSvc.putInSessionStoarage(
        COMMON_CONSTANTS.CONTENT,
        JSON.stringify(data.par.account_management_authoring)
      );
      ContentService.SetCache(
        COMMON_CONSTANTS.CONTENT,
        data.par.account_management_authoring
      );
    })
    .catch((error) => {
      console.log(error);
    });

  }
}
